var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClosePaymentModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 12.0008L17.2438 17.2438M6.75781 17.2438L12.0008 12.0008L6.75781 17.2438ZM17.2438 6.75781L11.9998 12.0008L17.2438 6.75781ZM11.9998 12.0008L6.75781 6.75781L11.9998 12.0008Z",
    stroke: "black",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosePaymentModal);
export default __webpack_public_path__ + "static/media/icon-close-payment-modal.092bc5594c583fb86f8099935d4319f0.svg";
export { ForwardRef as ReactComponent };